import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router";
import { useSelector } from "react-redux";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import TokenPot from "./TokenPot";
import ShoppingPremierToken from "./ShoppingPremierToken";
import TokenPotModal from "./TokenPotModal";
import TokenDescriptionModal from "./TokenDescriptionModal";
import "./index.css";
const defaultPots = [
  {
    img: "https://firebasestorage.googleapis.com/v0/b/boltconcierge-2f0f9.appspot.com/o/pots%2Fimages%2FEco%20Good%20Token.png?alt=media&token=d2260152-db5b-4d8a-adb7-1b7e67000da8",
    name: "Eco Good",
    isLive: false,
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/boltconcierge-2f0f9.appspot.com/o/pots%2Fimages%2FGroceries%20Token.png?alt=media&token=93d5c1c7-3ae8-4eec-b6e7-2a089f4c231f",
    name: "Groceries",
    isLive: false,
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/boltconcierge-2f0f9.appspot.com/o/pots%2Fimages%2FHome%20Token.png?alt=media&token=b8e082b4-d2a3-4cdc-af3a-ece1f0637cdb",
    name: "Home",
    isLive: false,
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/boltconcierge-2f0f9.appspot.com/o/pots%2Fimages%2FTech%20Token.png?alt=media&token=aeae40e3-b67b-44ee-856b-4166a983e9d5",
    name: "Tech",
    isLive: false,
  },
  {
    img: "https://firebasestorage.googleapis.com/v0/b/boltconcierge-2f0f9.appspot.com/o/pots%2Fimages%2FSocial%20Good%20Token.png?alt=media&token=4d7c31f8-5607-473b-99d7-bf2376696444",
    name: "Social Good",
    isLive: false,
  },
  {
    text: "Discount from your shopping baskets at between 1-20%, using the store and TokenPay shopping",
    isLive: true,
  },
  {
    text: "Spend as a private currency at *Currency* value through TokenPay and the marketplace, at unlimited value",
    isLive: true,
  },
];
const TokensAndPots = () => {
  const location = useLocation();
  const history = useHistory();
  const [brand_data, setBrandData] = useState({});
  const [brand, setBrand] = useState(null);
  const [role, setRole] = useState(null);
  const [username, setUserName] = useState("");
  const [loading, setLoading] = useState(false);
  const [openedPotIndex, setOpenedPotIndex] = useState(0);

  let tokenPots = brand_data.tokenPots || defaultPots;
  const territory = brand_data.territory || "UK";
  useEffect(() => {
    if (!location.state) {
      history.push("/");
    } else {
      const { brand, role, username } = location.state;
      setBrand(brand);
      setRole(role);
      setUserName(username);
      setLoading(true);
      Firebase.getBrandDataByID(brand, (brand_data) => {
        if (brand_data) {
          console.log("brand_data", brand_data);
          setBrandData(brand_data);
          setLoading(false);
        }
      });
    }
  }, [location]);

  const handleSavePotConf = async (data) => {
    let newTokenPots = [...tokenPots];
    newTokenPots[openedPotIndex] = data;
    await Firebase.updateBrandDataById(brand, { tokenPots: newTokenPots });
  };
  const handleSwitchStatus = async (index) => {
    const currentStatus = tokenPots[index].isLive;
    let newTokenPots = [...tokenPots];
    newTokenPots[index].isLive = !currentStatus;
    await Firebase.updateBrandDataById(brand, { tokenPots: newTokenPots });
  };
  const handleOpenModal = (index) => {
    setOpenedPotIndex(index);
  };
  return (
    <div id="page-container" className="articles-container">
      <Header
        username={username}
        role={role}
        logo={brand_data.logo}
        brand={brand}
        brandName={brand_data.name}
        is_property_brand={brand_data.is_property_brand}
      />
      <main id="main-container">
        {loading && (
          <div className="loading">
            <i className="fa fa-4x fa-sync fa-spin text-muted" />
          </div>
        )}
        {!loading && (
          <div className="my-container">
            <div className="pots-container">
              {tokenPots.slice(0, 5).map((item, index) => (
                <TokenPot
                  index={index}
                  key={index}
                  onEdit={() => handleOpenModal(index)}
                  onSwitchStatus={() => handleSwitchStatus(index)}
                  {...item}
                />
              ))}
            </div>
            <ShoppingPremierToken
              shoppingToken={tokenPots[5]}
              premierToken={tokenPots[6]}
              onSwitchStatus={handleSwitchStatus}
              territory={territory}
              onEdit={(index) => handleOpenModal(index)}
            />
          </div>
        )}
        <TokenPotModal
          data={tokenPots[openedPotIndex]}
          onSave={handleSavePotConf}
        />
        <TokenDescriptionModal
          data={tokenPots[openedPotIndex]}
          onSave={handleSavePotConf}
        />
      </main>
    </div>
  );
};

export default TokensAndPots;



// WEBPACK FOOTER //
// ./src/screens/TokensAndPots/index.js